import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-84e03d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_2 = { class: "popup-wrapper" }
const _hoisted_3 = { class: "popup-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "tm-receive-success-popup",
    onTouchmove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "know-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goWeChat && _ctx.goWeChat(...args)))
        }, _toDisplayString(_ctx.browserEnv === 2 ? '去转发' : '去微信转发'), 1),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTmForWardPopup(false)))
        }, _hoisted_6)
      ])
    ])
  ], 544)), [
    [_vShow, _ctx.isShowTmForWardPopup]
  ])
}